import api from "api/api";

// Fast & Furious — weekly declaration (datatrack service, cf. MR back !1008).
// Endpoints auto-scoped to the logged-in user: no ?scope= parameter.

// Catch-up window: 5-week carousel [current − 2 … current + 2] with
// their state (OPEN/BLOCKED/LOCKED/DRAFT/SUBMITTED). Replaces the former single-week /current.
// `options`: e.g. handleForbiddenLocally for a background call.
export const getDeclarationWindowQuery = async (options) =>
  await api.get(`/datatrack/declaration/window`, undefined, options);

// Full detail of a declaration (draft to resume): half_day_absences,
// recruitment_interview_count, status, points_total… (the /window cells are lightweight).
export const getDeclarationByIdQuery = async ({ id }) =>
  await api.get(`/datatrack/declaration/${id}`);

export const createDeclarationQuery = async ({ payload }) =>
  await api.post(`/datatrack/declaration`, payload);

export const updateDeclarationQuery = async ({ id, payload }) =>
  await api.patch(`/datatrack/declaration/${id}`, payload);

// Final submission: the back computes points_total and freezes the declaration (SUBMITTED).
export const submitDeclarationQuery = async ({ id }) =>
  await api.post(`/datatrack/declaration/${id}/submit`);
